// Phase P-3 · Packer Staff portal sub-nav.
// Bumped in lockstep with VersionWatcher + /api/build-info (read from
// MicroLeadSubNav's BUILD_STAMP). Triple-check parity on every release.
import { NavLink } from "react-router-dom";
import { LayoutDashboard, LogOut } from "lucide-react";
import useAuthStore from "../../store/authStore";

const BUILD_STAMP = "APP-1.0-r7";

export default function PackerSubNav() {
  const { user, logout } = useAuthStore();
  return (
    <div className="border-b border-slate-200 bg-white sticky top-0 z-30" data-testid="packer-subnav">
      <div className="max-w-[800px] mx-auto px-3 py-2.5 flex items-center gap-2">
        <div className="text-xs uppercase tracking-wider text-slate-500 font-semibold mr-1">
          Packer
        </div>
        <span className="text-sm font-medium text-slate-900 truncate" data-testid="packer-name">
          {user?.name || "—"}
        </span>
        <NavLink
          to="/packer/dashboard"
          end
          data-testid="packer-tab-dashboard"
          className={({ isActive }) =>
            "inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs ml-auto " +
            (isActive
              ? "bg-[#FF6B00] text-white shadow-sm"
              : "bg-slate-100 hover:bg-slate-200 text-slate-700")
          }>
          <LayoutDashboard className="h-3.5 w-3.5" />Dashboard
        </NavLink>
        <button
          onClick={logout}
          aria-label="Log out"
          data-testid="packer-logout"
          className="inline-flex items-center gap-1 px-2 py-1 text-xs text-slate-600 hover:text-rose-600">
          <LogOut className="h-3.5 w-3.5"/>
        </button>
        <span className="text-[10px] font-mono text-slate-400"
              title="If older than the latest release, hard-refresh (Ctrl+Shift+R) — VersionWatcher should auto-prompt."
              data-testid="packer-build-stamp">
          {BUILD_STAMP}
        </span>
      </div>
    </div>
  );
}
